module.exports = __webpack_public_path__ + "static/media/card-Discover-mobile.d08bca81.svg";